<template>
  <div id="app" v-scroll="handleScroll">
    <div :class="scrollTopbg ? 'header-fixdebg' : 'header-fixde'">
      <!-- header -->
      <div :class="scrollTopbg ? 'headerbg' : 'header'">
        <div class="logo_img" @click="logoClick">
          <div style="
              display: flex;
              align-items: center;
              float: left;
              height: 65px;
            ">
            <div class="header-logo">
              <img id="header-img" @click="activeIndex = 1" :src="$route.name == 'Index'
                  ? scrollTopbg
                    ? require('../assets/2023/08/company-search-logo-light.png')
                    : require('../assets/2023/08/company-search-logo.png')
                  : require('../assets/2023/08/company-search-logo.png')
                " />
            </div>
          </div>
        </div>
        <div id="menu_index">
          <!-- web端菜单导航 -->
          <el-menu v-if="screenWidth > 1000" :default-active="activeIndex" :active-text-color="$route.name == 'Index' ? (scrollTopbg ? '#fff' : '#000') : '#000'
            " class="el-menu-demo" menu-trigger="hover" :text-color="$route.name == 'Index' ? (scrollTopbg ? '#fff' : '#000') : '#000'
              " style="height: 70px; border: 0" mode="horizontal" :unique-opened="true" @select="handleSelect">
            <el-submenu index="2" :hide-timeout="1000" popper-class="elmenuitem" class="header-title">
              <template slot="title"><span class="header-title" :class="activeIndex != '2'
                  ? scrollTopbg
                    ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                    : 'hvr-underline-from-left hvr-underline-from-leftblack'
                  : ''
                ">Products</span></template>
              <el-menu-item index="2-1" class="header-titleitem" @click="scrollToAnchor('#BusinessIntelligence')"><img
                  class="titleitem-img" src="../assets/2023/08/bi-icon.gif" alt="" /><span>Business Intelligence
                  (BI)</span></el-menu-item>
              <el-menu-item index="2-2" class="header-titleitem" @click="scrollToAnchor('#BusinessAnalytics')"><img
                  class="titleitem-img" src="../assets/2023/08/ba-icon.gif" alt="" /><span>Business Analytics
                  (BA)</span></el-menu-item>
              <el-menu-item index="2-3" class="header-titleitem" @click="scrollToAnchor('#BusinessCredit')"><img
                  class="titleitem-img" src="../assets/2023/08/bcr-icoc.gif" alt="" /><span>Business Credit
                  Reports</span></el-menu-item>
              <el-menu-item index="2-4" class="header-titleitem" @click="scrollToAnchor('#DataService')"><img
                  class="titleitem-img" src="../assets/2023/08/data-icon.gif" alt="" /><span>Data
                  Service</span></el-menu-item>
            </el-submenu>
            <el-submenu index="3" :hide-timeout="1000" popper-class="elmenuitem" class="header-title">
              <template slot="title"><span class="header-title" :class="activeIndex != '3'
                  ? scrollTopbg
                    ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                    : 'hvr-underline-from-left hvr-underline-from-leftblack'
                  : ''
                ">Solutions</span></template>
              <div class="flex-center">
                <el-menu-item index="3-1" @click="scrollToAnchortwo('#Card', 3)"
                  class="header-titleitem flex-center"><img class="titleitem-img" src="../assets/2023/08/bi-icon.gif"
                    alt="" />
                  <div>
                    <span class="flex-item">Business </span><br /><span>Intelligence
                    </span>
                  </div>
                </el-menu-item>
                <el-menu-item index="3-2" @click="scrollToAnchortwo('#Card', 8)"
                  class="header-titleitem flex-center"><img class="titleitem-img"
                    src="../assets/2023/10/Financial-Overview.gif" alt="" />
                  <div>
                    <span class="flex-item">Financial </span><br /><span>Overview</span>
                  </div>
                </el-menu-item>
                <el-menu-item index="3-3" @click="scrollToAnchortwo('#Card', 13)"
                  class="header-titleitem flex-center"><img class="titleitem-img" src="../assets/2023/08/gt-icon.gif"
                    alt="" />
                  <div>
                    <span class="flex-item">Market </span><br /><span>
                      Research</span>
                  </div>
                </el-menu-item>
              </div>
              <div class="flex-center">
                <el-menu-item index="3-4" @click="scrollToAnchortwo('#Card', 4)"
                  class="header-titleitem flex-center"><img class="titleitem-img" src="../assets/2023/08/ba-icon.gif"
                    alt="" />
                  <div>
                    <span class="flex-item">Business </span><br /><span>Analytics
                    </span>
                  </div>
                </el-menu-item>
                <el-menu-item index="3-5" @click="scrollToAnchortwo('#Card', 9)"
                  class="header-titleitem flex-center"><img class="titleitem-img"
                    src="../assets/2023/10/Examine-Import-Export.gif" alt="" />
                  <div>
                    <span class="flex-item">Examine </span><br /><span>Import-Export</span>
                  </div>
                </el-menu-item>
                <el-menu-item index="3-6" @click="scrollToAnchortwo('#Card', 14)"
                  class="header-titleitem flex-center"><img class="titleitem-img" src="../assets/2023/10/credit.gif"
                    alt="" />
                  <div>
                    <span class="flex-item">Credit </span><br /><span>Assessment</span>
                  </div>
                </el-menu-item>
              </div>
              <div class="flex-center">
                <el-menu-item index="3-7" @click="scrollToAnchortwo('#Card', 5)"
                  class="header-titleitem flex-center"><img class="titleitem-img" src="../assets/2023/08/vs-icon.gif"
                    alt="" />
                  <div>
                    <span class="flex-item">Vendor </span><br /><span>Screening
                    </span>
                  </div>
                </el-menu-item>
                <el-menu-item index="3-8" @click="scrollToAnchortwo('#Card', 10)"
                  class="header-titleitem flex-center"><img class="titleitem-img" src="../assets/2023/10/legal.gif"
                    alt="" />
                  <div>
                    <span class="flex-item" style="line-height: 35px !important">Legal
                    </span>
                  </div>
                </el-menu-item>
                <el-menu-item index="3-9" @click="scrollToAnchortwo('#Card', 15)"
                  class="header-titleitem flex-center"><img class="titleitem-img" src="../assets/2023/08/nab-icon.gif"
                    alt="" />
                  <div>
                    <span class="flex-item" style="line-height: 35px !important">News
                    </span>
                  </div>
                </el-menu-item>
              </div>
              <div class="flex-center">
                <el-menu-item index="3-10" class="header-titleitem flex-center"
                  @click="scrollToAnchortwo('#Card', 6)"><img class="titleitem-img" src="../assets/2023/08/kyc-icon.gif"
                    alt="" />
                  <div>
                    <span class="flex-item" style="line-height: 35px !important">KYC
                    </span>
                  </div>
                </el-menu-item>
                <el-menu-item index="3-11" @click="scrollToAnchortwo('#Card', 11)"
                  class="header-titleitem flex-center"><img class="titleitem-img" src="../assets/2023/08/ma-icon.gif"
                    alt="" />
                  <div>
                    <span class="flex-item" style="line-height: 35px !important">Marketing
                    </span>
                  </div>
                </el-menu-item>
                <el-menu-item index="3-12" @click="scrollToAnchortwo('#Card', 16)"
                  class="header-titleitem flex-center"><img class="titleitem-img" src="../assets/2023/10/sanction.gif"
                    alt="" />
                  <div>
                    <span class="flex-item" style="line-height: 35px !important">Sanctions
                    </span>
                  </div>
                </el-menu-item>
              </div>
              <div class="flex-center">
                <el-menu-item index="3-13" @click="scrollToAnchortwo('#Card', 7)"
                  class="header-titleitem flex-center"><img class="titleitem-img"
                    src="../assets/2023/10/Ownership-Penetration.gif" alt="" />
                  <div>
                    <span class="flex-item">Ownership </span><br /><span>Penetration</span>
                  </div>
                </el-menu-item>
                <el-menu-item index="3-14" @click="scrollToAnchortwo('#Card', 12)"
                  class="header-titleitem flex-center"><img class="titleitem-img" src="../assets/2023/08/ram-icon.gif"
                    alt="" />
                  <div>
                    <span class="flex-item">Industry </span><br /><span>Analysls</span>
                  </div>
                </el-menu-item>
              </div>
            </el-submenu>
            <el-menu-item index="4" class="header-title" @click="scrollToAnchor('#Whoweserve')"><span :class="activeIndex != '4'
                ? scrollTopbg
                  ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                  : 'hvr-underline-from-left hvr-underline-from-leftblack'
                : ''
              ">Who we serve</span></el-menu-item>
            <!--   hvr-underline-from-left -->
            <el-submenu index="5" popper-class="elmenuitem" class="header-title" :hide-timeout="1000">
              <template slot="title"><span class="header-title" :class="activeIndex != '5'
                  ? scrollTopbg
                    ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                    : 'hvr-underline-from-left hvr-underline-from-leftblack'
                  : ''
                ">Resources</span></template>
              <el-menu-item index="5-1" @click="scrollToAnchor('#Insights')" class="header-titleitem"><img
                  class="titleitem-img" src="../assets/2023/08/insights-icon.gif" alt="" />Insights</el-menu-item>
              <el-menu-item index="5-2" @click="scrollToAnchor('#Insights')" class="header-titleitem"><img
                  class="titleitem-img" src="../assets/2023/08/nab-icon.gif" alt="" />Company News &
                Blogs</el-menu-item>
              <el-menu-item index="5-3" @click="scrollToAnchor('#Insights')" class="header-titleitem"><img
                  class="titleitem-img" src="../assets/2023/08/webinar-icon.gif" alt="" />Webinars</el-menu-item>
            </el-submenu>
            <el-menu-item index="6" class="header-title"><span :class="activeIndex != '6'
                ? scrollTopbg
                  ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                  : 'hvr-underline-from-left hvr-underline-from-leftblack'
                : ''
              ">About us</span>
              <!-- hvr-underline-from-left -->
            </el-menu-item>
          </el-menu>

          <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
        </div>
        <div class="header-title searchmenu" v-if="screenWidth > 1000"
          style="float: right; display: flex; align-items: center; height: 100%">
          <!-- <el-button
            icon="el-icon-search"
            type="primary"
         
            @click="register"
            round
            >Search
            
            </el-button
            
          > -->
          <el-menu :default-active="activeIndex" :active-text-color="$route.name == 'Index' ? (scrollTopbg ? '#fff' : '#000') : '#000'
            " class="el-menu-demo" menu-trigger="hover" :text-color="$route.name == 'Index' ? (scrollTopbg ? '#fff' : '#000') : '#000'
              " style="height: 70px; border: 0" mode="horizontal" :unique-opened="true">
            <el-submenu index="8">
              <template slot="title">
                <b class="el-icon-search" :class="scrollTopbg
                    ? 'el-icon-search'
                    : 'el-icon-search el-icon-searchblack'
                  "></b>
                <span class="header-title" :class="activeIndex != '8'
                    ? scrollTopbg
                      ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                      : 'hvr-underline-from-left hvr-underline-from-leftblack'
                    : ''
                  ">Search</span></template>
              <el-menu-item index="1-1" @click="register('csi')" class="header-titleitem header-titleitemtwo">
                <div class="titleiteemu-text" style="width:75px">
                  <img class="" src="../assets/2024/05/截屏2024-08-02 18.11.00.png" style="height: 30px" alt="" />
                </div>
                <span>Company Search Business Intelligence Platform</span>
              </el-menu-item>
              <el-menu-item index="1-2" @click="register('udm')" class="header-titleitem header-titleitemtwo">
                <div class="titleiteemu-text">
                  <img class="titleiteemu-img" src="../assets/2024/05/截屏2024-08-02 17.26.45.png" alt="" />
                </div>
                <span>You-da-Man Business Analytic Platform</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <div v-if="screenWidth < 1000" style="float: right; display: flex; align-items: center; height: 100%">
          <svg t="1721896889774" @click="drawer = true" v-if="scrollTopbg" class="icon" viewBox="0 0 1024 1024"
            version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16569" width="25" height="25">
            <path
              d="M96 160h832c19.2 0 32 12.8 32 32s-12.8 32-32 32h-832c-19.2 0-32-12.8-32-32s12.8-32 32-32z m0 320h832c19.2 0 32 12.8 32 32s-12.8 32-32 32h-832c-19.2 0-32-12.8-32-32s12.8-32 32-32z m0 320h832c19.2 0 32 12.8 32 32s-12.8 32-32 32h-832c-19.2 0-32-12.8-32-32s12.8-32 32-32z"
              fill="#ffffff" p-id="16570"></path>
          </svg>
          <svg t="1721896889774" @click="drawer = true" v-if="!scrollTopbg" class="icon" viewBox="0 0 1024 1024"
            version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16569" width="25" height="25">
            <path
              d="M96 160h832c19.2 0 32 12.8 32 32s-12.8 32-32 32h-832c-19.2 0-32-12.8-32-32s12.8-32 32-32z m0 320h832c19.2 0 32 12.8 32 32s-12.8 32-32 32h-832c-19.2 0-32-12.8-32-32s12.8-32 32-32z m0 320h832c19.2 0 32 12.8 32 32s-12.8 32-32 32h-832c-19.2 0-32-12.8-32-32s12.8-32 32-32z"
              fill="#000000" p-id="16570"></path>
          </svg>
        </div>
      </div>
    </div>
    <div class="container" style="clear: both">
      <!-- 视频 -->
      <div v-show="$route.name == 'Index'">
        <div class="nectar-video-inner">
          <div class="row-bg-overlay row-bg-layer" style="background-color: #000000; opacity: 0.6"></div>
          <video class="nectar-video-bg" width="100%" height="auto" preload="auto" loop="" autoplay="" muted=""
            playsinline="" style="
              visibility: visible;
              width: 100%;
              height: 100%;
              object-fit: cover;
              max-height: 800px;
            ">
            <source src="../assets/other/mixkit-bluish-data-center-hallway-23282-hd-ready.mp4" type="video/mp4" />
          </video>
          <div class="video-content">
            <div class="video-content-left">
              <p class="video-content-title">Bringing Global Business</p>
              <div class="start_font">
                <span class="step3">To </span><span class="wight_bold focus step4"></span>
              </div>
              <p class="seach-icon">
                <i class="el-icon-search"></i>
                <span class="hvr-underline-from-left hvr-underline-from-leftwrite"
                  style="cursor: pointer;font-weight 400;font-family:Roboto;font-weight:400"
                  @click="register('csi')">Search</span>
              </p>
            </div>
            <div class="video-content-right">
              <img class="postion" src="../assets/Pictures for the Main Cover.gif" alt="" />
            </div>
          </div>
        </div>
        <div class="about-box">
          <h2 id="Whoweserve" v-show="starttop > 900" class="animate__animated animate__fadeInUp"
            style="font-size: 46px; max-width: 62%; margin-top: 0px">
            We are a resource for organizations of all sizes and in almost every
            industry
          </h2>
          <div>
            <div class="banshi">
              <swiper :mobel="mobile"></swiper>
              <!-- <div class="resource-container">
                <div class="swiper-wrapper one-wrapper ">
                  <div
                    v-for="(item, index) in organizationsimgs"
                    :key="index"
                    class="resource-slide"
                  >
                    <img
                      :src="item.img"
                      style="height: 80%; width: 100%"
                      alt=""
                    />
                    <p style="color: #1290c9;font-weight: 600;">{{ item.title }}</p>
                  </div>
                </div>
                <div class="swiper-button-next">
                  <i class="el-icon-back"></i>
                </div>
                <div class="swiper-button-prev">
                  <i class="el-icon-back"></i>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="Engineering" ref="OurData">
          <div class="about-box">
            <h2 v-show="OurDatafalse" class="animate__animated animate__fadeInUp" style="
                font-size: 46px;
                max-width: 62%;
                margin-top: 0px;
                color: #fff;
              ">
              Our Data Engineering
            </h2>
            <p class="contert-text" style="color: #fff; font-weight: 100">
              We collect data from all available sources, and work with reliable
              partners all around the world. Our data quality index (DQI)
              focuses on data coverage, reliability, consistency and live data
              updates. We process and analyze a large amount of data to make
              data meaningful information. We provide digital research tools for
              professional investors and business managers worldwide.
            </p>
          </div>
          <div style="position: relative" ref="OurDataEngineering">
            <div class="bg-count flex-just-sapce" v-if="OurDataEngineeringishow">
              <div class="bg-count-item">
                <div class="symbol-wrap">
                  <countTo class="contnum" :startVal="startVal" :endVal="endVal" :duration="duration"></countTo>
                  <span class="symbol">+</span>
                  <span class="">m</span>
                </div>
                <span style="color: #0169be; margin-left: -46px">Companies</span>
              </div>
              <div class="bg-count-item">
                <div class="symbol-wrap">
                  <countTo class="contnum" :startVal="startVal" :endVal="200" :duration="duration"></countTo>
                  <span class="symbol">+</span>
                  <span class="">m</span>
                </div>
                <span style="color: #0169be">Countries / Territories</span>
              </div>
              <div class="bg-count-item">
                <div class="symbol-wrap">
                  <countTo class="contnum" :startVal="startVal" :endVal="150" :duration="duration"></countTo>
                  <span class="symbol" style="right: 20%">+</span>
                  <span class="">m</span>
                </div>
                <span style="color: #0169be; margin-left: -46px">Performance</span>
              </div>
              <div class="bg-count-item">
                <div class="symbol-wrap">
                  <countTo class="contnum" :startVal="startVal" :endVal="340" :duration="duration"></countTo>
                  <span class="symbol">+</span>
                  <span class="">m</span>
                </div>
                <span style="color: #0169be; margin-left: -46px">Relationships</span>
              </div>
              <div class="bg-count-item">
                <div class="symbol-wrap">
                  <countTo class="contnum" :startVal="startVal" :endVal="200" :duration="duration"></countTo>
                  <span class="symbol">+</span>
                  <span class="">m</span>
                </div>
                <span style="color: #0169be; margin-left: -46px">KYC</span>
              </div>
              <div class="bg-count-item">
                <div class="symbol-wrap">
                  <countTo class="contnum" :startVal="startVal" :endVal="1.2" :decimals="2" :duration="duration">
                  </countTo>
                  <span class="symbol" style="right: 14%">+</span>
                  <span class="">b</span>
                </div>
                <span style="color: #0169be">Import & Export</span>
              </div>
            </div>
            <div class="bg-xuxian flex-just-sapce" v-if="seen">
              <div class="nectar-bg-white">
                <div class="divider-vertical"></div>
              </div>

              <div class="nectar-bg-white">
                <div class="divider-vertical"></div>
              </div>
              <div class="nectar-bg-white">
                <div class="divider-vertical"></div>
              </div>
              <div class="nectar-bg-white">
                <div class="divider-vertical"></div>
              </div>
              <div class="nectar-bg-white">
                <div class="divider-vertical"></div>
              </div>
              <div class="nectar-bg-white">
                <div class="divider-vertical"></div>
              </div>
              <div class="nectar-bg-white">
                <div class="divider-vertical"></div>
              </div>
              <div class="nectar-bg-white">
                <div class="divider-vertical"></div>
              </div>
              <div class="nectar-bg-white">
                <div class="divider-vertical"></div>
              </div>
              <div class="nectar-bg-white">
                <div class="divider-vertical"></div>
              </div>
            </div>
            <div ref="ecahrt">
              <div class="bg-xuxiantwo flex-just-sapce" v-show="seen">
                <!-- <div class="flex-just-sapce"> -->
                <div class="" style="flex: 1">
                  <div class="ecahrt">
                    <div id="dataQuality" ref="dataQuality" style="width: 100%; height: 154px"></div>
                    <countTo class="bbb" suffix="%" :startVal="startVal" :endVal="97" :duration="duration"></countTo>
                  </div>
                </div>
                <div class="" style="flex: 1">
                  <div class="ecahrt">
                    <div id="dataQuality" ref="dataQuality1" style="width: 100%; height: 154px"></div>
                    <countTo class="bbb" suffix="%" :startVal="startVal" :endVal="85" :duration="duration"></countTo>
                  </div>
                </div>
                <!-- </div> -->
                <!-- <div class="flex-just-sapce"> -->
                <div class="" style="flex: 1">
                  <div class="ecahrt">
                    <!-- <div
                    id="dataQuality"
                    ref="dataQuality5"
            style="width: 100%; height: 154px"
                  ></div>
                  <countTo
                    class="bbb"
                    suffix="%"
                    :startVal="startVal"
                    :endVal="89"
                    :duration="duration"
                  ></countTo> -->
                  </div>
                </div>
                <div class="" style="flex: 1">
                  <div class="ecahrt">
                    <!-- <div
                    id="dataQuality"
                    ref="dataQuality6"
                   style="width: 100%; height: 154px"
                  ></div>
                  <countTo
                    class="bbb"
                    suffix="%"
                    :startVal="startVal"
                    :endVal="94"
                    :duration="duration"
                  ></countTo> -->
                  </div>
                </div>
                <!-- </div> -->
                <!-- <div class="flex-just-sapce"> -->
                <div class="" style="flex: 1">
                  <div class="ecahrt">
                    <div id="dataQuality" ref="dataQuality5" style="width: 100%; height: 154px"></div>
                    <countTo class="bbb" suffix="%" :startVal="startVal" :endVal="89" :duration="duration"></countTo>
                  </div>
                </div>
                <div class="" style="flex: 1">
                  <div class="ecahrt">
                    <div id="dataQuality" ref="dataQuality6" style="width: 100%; height: 154px"></div>
                    <countTo class="bbb" suffix="%" :startVal="startVal" :endVal="94" :duration="duration"></countTo>
                  </div>
                </div>
                <div class="" style="flex: 1">
                  <div class="ecahrt">
                    <!-- <div
                    id="dataQuality"
                    ref="dataQuality9"
                    style="width: 100%; height: 154px"
                  ></div>
                  <countTo
                    class="bbb"
                    suffix="%"
                    :startVal="startVal"
                    :endVal="75"
                    :duration="duration"
                  ></countTo> -->
                  </div>
                </div>
                <div class="" style="flex: 1">
                  <div class="ecahrt">
                    <div id="dataQuality" ref="dataQuality7" style="width: 100%; height: 154px"></div>
                    <countTo class="bbb" suffix="%" :startVal="startVal" :endVal="90" :duration="duration"></countTo>
                  </div>
                </div>
                <div class="" style="flex: 1">
                  <div class="ecahrt">
                    <div id="dataQuality" ref="dataQuality8" style="width: 100%; height: 154px"></div>
                    <countTo class="bbb" suffix="%" :startVal="startVal" :endVal="99" :duration="duration"></countTo>
                  </div>
                </div>
                <div class="" style="flex: 1">
                  <div class="ecahrt">
                    <div id="dataQuality" ref="dataQuality9" style="width: 100%; height: 154px"></div>
                    <countTo class="bbb" suffix="%" :startVal="startVal" :endVal="75" :duration="duration"></countTo>
                  </div>
                </div>
                <!-- </div> -->
              </div>
            </div>
          </div>
          <div v-show="!seen" style="text-align: center">
            <img v-if="imgmobile" src="../assets/2023/11/map-300x169.png" alt="" />
            <img v-else width="600px" src="../assets/2023/11/map-768x432.png" alt="" />
          </div>
          <p class="wpb_wrapper" v-if="seen">Coverage</p>
        </div>
        <div id="Card"></div>
        <div class="about-box">
          <div style="margin-bottom: 10%">
            <div class="">
              <div class="swiper-Solutions swiper-container">
                <div class="swiper-wrapper">
                  <div v-for="(item, index) in organizationsimgstwo" :key="index" class="swiper-slide">
                    <div class="soction-slide">
                      <h3 class="soction-slide-titel">{{ item.title }}</h3>
                      <ul>
                        <li v-for="(ite, ind) in item.li" :key="ind">
                          {{ ite }}
                        </li>

                        <div class="isactiveimg" v-if="item.img.length > 0">
                          <img :src="item.img" style="width: 100%; height: 100%" alt="" />
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="swiper-pagination"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="about-boxtwo" id="BusinessIntelligence">
          <div class="flex-just-sapce">
            <div class="flex-left">
              <h2 class="h2title" ref="echarts">
                Business Intelligence <b class="tex-xiahuaxian"> (BI)</b>
              </h2>
              <p v-show="echartsfalse" class="contert-text animate__animated animate__fadeInUp">
                Company Search Business Intelligence Platform (CSI) is a search engine for global business
                intelligence. We capture more than 450 million companies
                covering more than 200 countries and territories. We help users
                to identify companies instantly, find out valid contact info,
                verify registration records, study ownership structure, review
                business activities, including import and export records and
                public records available. CSI BI Platform offers supporting
                services including business process verification, due diligence
                and data services. CSI BI Platform is a very useful tool for
                professionals in almost all industries.
                For service plan and pricing, please contact us at request@csibizinfo.com
              </p>
              <p class="block felx_center">
                <img style="height:27px; width: 24px;" src="../assets/2023/10/截屏2024-07-02 15.46.07.png" alt="" />
                <a class="hvr-underline-from-left hvr-underline-from-leftbluewer felx_center"
                  style="border-color: #1290c9; text-decoration: none" href="https://csibizsearch.com/">Learn more about
                  <img class="" src="../assets/2024/05/截屏2024-08-02 18.11.00.png" style="height: 31px;margin-left:7px"
                    alt="" /></a>
              </p>
            </div>
            <div class="flex-right">
              <img style="height: 250px; width: 350px"
                src="../assets/2023/10/product-Business-Intelligence-img-768x591.png" alt="" />
            </div>
          </div>
        </div>
        <div class="about-boxtwo" id="BusinessAnalytics">
          <div class="flex-just-sapce">
            <div class="flex-right ">
              <img style="height: 250px; width: 350px"
                src="../assets/2023/10/product-Business-Analytics-img-768x591.png" alt="" />
            </div>
            <div class="flex-left">
              <h2 class="h2title" ref="echartstwo">
                Business Analytics<b class="tex-xiahuaxian"> (BA)</b>
              </h2>
              <p v-show="echartstwofalse" class="contert-text animate__animated animate__fadeInUp">
                You-da-Man Business Analytic Platform (UDM) is a smart research platform, driven by reliable big data,
                providing decision makers with analytic tools to manage market
                and business opportunities in global markets. UDM is a new generation
                intuitive research platform supported by various algorithms and
                model building for in-depth analysis. UDM’s products and
                services provide objective, reliable, systematic, instant and
                visual business insight for investors, researchers and decision
                makers to manage opportunities and risks effectively and
                efficiently in the global markets place.
              </p>
              <p class="block felx_center">
                <img style="height:27px; width: 24px;" src="../assets/2023/10/截屏2024-07-02 15.46.07.png" alt="" />
                <a class="hvr-underline-from-left hvr-underline-from-leftbluewer felx_center"
                  style="border-color: #1290c9; text-decoration: none" href="https://www.udmrnd.com"> Learn more about
                  <img class="titleiteemu-img" style="height:33px;margin-left:0px"
                    src="../assets/2024/05/截屏2024-08-02 17.26.45.png" alt="" /></a>
              </p>
            </div>
          </div>
        </div>
        <div class="about-boxtwo" id="BusinessCredit">
          <div class="flex-just-sapce">
            <div class="flex-left" style="width: 48%">
              <h2 class="h2title" ref="echarts3">
                Business <b class="tex-xiahuaxian"> Credit Reports</b>
              </h2>
              <div v-show="echarts3false" class="contert-text animate__animated animate__fadeInUp">
                CSI is an essential source for current and credible performance
                information for companies and markets of interest to you. These
                reports are created and managed by experienced professionals who
                understand the value of timely, accurate information. We strive
                to provide performance metrics that are important to the risk
                management process when establishing a business relationship
              </div>
              <div ref="echarts4"></div>
              <ul v-show="echarts4false" class="iwt-textul animate__animated animate__fadeInUp">
                <li>Reliable information to help you make credit decisions.</li>
                <li>
                  CDetailed information on solvency, finance and business
                  performance.
                </li>
                <li>
                  Access to an extensive network of global partners allows us to
                  deliver a standardized, uniformly structured report.
                </li>
                <li>
                  Highest standards of report quality and freshness supported by
                  standardized assessment processes and extensive research.
                </li>
              </ul>
              <p class="block">
                <img src="../assets/2023/10/截屏2024-07-02 15.46.07.png" alt="" />
                <a class="hvr-underline-from-left hvr-underline-from-leftbluewer"
                  style="border-color: #1290c9; text-decoration: none" href="https://csibizsearch.com/">Test a free
                  report</a>
              </p>
            </div>
            <div class="flex-right">
              <img style="height: 100%; width: 500px"
                src="../assets/2023/10/product-Business-Credit-Reports-img-768x570.png" alt="" />
            </div>
          </div>
        </div>
        <div class="about-boxtwo" id="DataService">
          <div class="flex-just-sapce">
            <div class="flex-right" style="margin-right: 20px">
              <img style="height: 293px; width: 380px" src="../assets/2023/10/product-Data-Service-img-768x592.png"
                alt="" />
            </div>
            <div class="flex-left">
              <h2 class="h2title">
                <b class="tex-xiahuaxian" ref="echarts5"> Data</b> Service
              </h2>
              <p v-show="echarts5false" class="contert-text animate__animated animate__fadeInUp">
                CSI’s data quality solutions will meet your needs for effective
                and efficient data management.
              </p>
              <p class="title-head animate__animated animate__fadeInUp">
                Data cleansing:
              </p>
              <p v-show="echarts5false" class="contert-text animate__animated animate__fadeInUp">
                Data Cleansing is an important part of managing customer and
                vendor profiles effectively. This ensures the data is accurate,
                complete and up to date. We can clean, standardize, update,
                analyze and enhance data to ensure our subscribers have access
                to high quality data while making informed decisions
              </p>
              <p ref="echarts6" class="title-head animate__animated animate__fadeInUp">API:</p>
              <p v-show="echarts6false" class="contert-text animate__animated animate__fadeInUp">
                Connect CSI’s largest structured B2B database directly into your
                applications. You can access information in real time and use it
                to improve your business processes. CSI’s API is easy to use and
                flexible. You can also customize the API to meet your specific
                needs.
              </p>
              <p class="title-head animate__animated animate__fadeInUp">
                Bulk data:
              </p>
              <div v-show="echarts6false" class="contert-text animate__animated animate__fadeInUp">
                If you’re running analytics, model building, or Al training and
                need sufficient data support, CSI can assist you.
              </div>
              <p class="block">
                <img src="../assets/2023/10/截屏2024-07-02 15.46.07.png" alt="" />
                <a class="hvr-underline-from-left hvr-underline-from-leftbluewer"
                  style="border-color: #1290c9; text-decoration: none" href="#">Contact us</a>
              </p>
            </div>
          </div>
        </div>
        <div class="about-box-bottom" style="margin-top: 3%" id="Insightstwo">
          <el-tabs id="Insights" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane id="Insightstree" label="Insights" name="Insights">
              <swipertree></swipertree>
              <!-- <div class="flex-just-sapce" style="">
                <div class="bottom-conternt">
                  <a
                    class="nectar-post-grid-link"
                    href="https://csi.metadesigndemos.com/ai-can-be-beneficial-for-the-marketing-process-2/"
                    aria-label="AI can be beneficial for the marketing process"
                  >
                    <img
                      class="bottom-img"
                      src="../assets/2024/01/655d836e7c89f6993fe4cf05_X-examples-of-AI-generated-content_blog-listing-768x614.png"
                      alt=""
                      style="height: 215px"
                    />
                    <div style="padding: 0px 20px" class="huipostrive">
                      <p class="bigsize">
                        AI can be beneficial for the marketing process
                      </p>
                      <span class="meta-date">January 30, 2024</span>
                      <p class="text-overhidden">
                        Do you have a to-do list of pesky tasks lingering over
                        you? We’re talking about…
                      </p>
                      <div class="huisostion">
                        <span class="huibutton huibuttonabsolute"
                          >Insights</span
                        >
                      </div>
                    </div>
                  </a>
                </div>
                <div class="bottom-conternt">
                  <a
                    class="nectar-post-grid-link"
                    href="https://www.mckinsey.com/capabilities/mckinsey-digital/our-insights/a-data-leaders-technical-guide-to-scaling-gen-ai/"
                    aria-label="AI can be beneficial for the marketing process"
                  >
                    <img
                      class="bottom-img"
                      src="../assets/2024/05/202408.png"
                      alt=""
                      style="height: 215px"
                    />
                    <div style="padding: 0px 20px" class="huipostrive">
                      <p class="bigsize">
                        A data leader’s technical guide to scaling gen AI
                      </p>
                      <span class="meta-date">July 08, 2024</span>
                      <p class="text-overhidden">
                        The emergence of gen AI is forcing data and AI leaders
                        to revisit their data platforms...
                      </p>
                      <div class="huisostion">
                        <span class="huibutton">Insights</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="bottom-conternt">
                  <a
                    class="nectar-post-grid-link"
                    href="https://www.nytimes.com/2024/07/09/business/economy/economic-data-response-rates/"
                    aria-label="AI can be beneficial for the marketing process"
                  >
                    <img
                      class="bottom-img"
                      src="../assets/2024/05/july09 2024.png"
                      style="height: 215px"
                      alt=""
                    />
                    <div style="padding: 0px 20px" class="huipostrive">
                      <p class="bigsize">
                        Data Reliability: U.S. Economic Data Is in Jeopardy,
                        Study Finds
                      </p>
                      <span class="meta-date">July 09, 2024</span>
                      <p class="text-overhidden">
                        A report issued on July 2, 2024 by the American
                        Statistical Association concludes that government...
                      </p>
                      <div class="huisostion">
                        <span class="huibutton huibuttonabsolute"
                          >Insights</span
                        >
                      </div>
                    </div>
                  </a>
                </div>
                <div class="bottom-conternt">
                  <a
                    class="nectar-post-grid-link"
                    href="https://gfmag.com/economics-policy-regulation/esg-in-asia/"
                    aria-label="AI can be beneficial for the marketing process"
                  >
                    <img
                      class="bottom-img"
                      src="../assets/2024/05/2024 02.png"
                      alt=""
                      style="height: 215px"
                    />
                    <div style="padding: 0px 20px" class="huipostrive">
                      <p class="bigsize">ESG's Future in Asia</p>
                      <span class="meta-date">April 02, 2024</span>
                      <p class="text-overhidden">
                        The future path of ESG may well depend on choices made
                        by the rest of the world, and particularly Asia. Why
                        Asia?
                      </p>
                      <div class="huisostion">
                        <span class="huibutton">Insights</span>
                      </div>
                    </div>
                  </a>
                </div>
              </div> -->
            </el-tab-pane>
            <el-tab-pane label="Company News & Blogs" name="Company">
              <!-- <div class="flex-just-sapce" style="">
                  <div class="bottom-conternt bottom-conternttwo">
                  <a
                    class="nectar-post-grid-link"
                    href="https://www.cio.com/article/2517449/7-razones-por-las-que-la-analitica-y-el-aprendizaje-automatico-no-cumplen-los-objetivos-empresariales.html"
                    aria-label="AI can be beneficial for the marketing process"
                  >
                    <img
                      class="bottom-img"
                      src="../assets/2024/05/cio.png"
                      alt=""
                    />
                    <div style="padding: 0px 20px">
                      <p class="bigsize">
                      CSI featured in CIO.com (Spanish): 7 reasons analytics and ML fail to meet business objectives
                      </p>
                      <span class="meta-date">August 08, 2024</span>
                      <p class="text-overhidden">
                       Paul Boynton Co-Founder and COO of CSI is featured in a trending article about Machine Learning in CIO.com.
                      </p>

                      <div class="huisostion">
                        <span class="huibutton huibuttonabsolute"
                          >Company News & Blogs</span
                        >
                      </div>
                    </div>
                  </a>
                </div>
                <div class="bottom-conternt bottom-conternttwo">
                  <a
                    class="nectar-post-grid-link"
                    href="https://www.ictfworld.org/events/EventDetails.aspx?id=1780725&group="
                    aria-label="AI can be beneficial for the marketing process"
                  >
                    <img
                      class="bottom-img"
                      src="../assets/2024/05/图片4.png"
                      alt=""
                    />
                    <div style="padding: 0px 20px" class="huipostrive">
                      <p class="bigsize">
                        CSI Participates in ICTF's Global Credit Professionals
                        Symposium, Las Vegas
                      </p>
                      <span class="meta-date">April 7-9, 2024</span>
                      <p class="text-overhidden">
                        CSI is a sponsor of ICTF, a premier association for
                        executives in international credit, trade and finance...
                      </p>
                      <div class="huisostion">
                        <span class="huibutton huibuttonabsolute"
                          >Company News & Blogs</span
                        >
                      </div>
                    </div>
                  </a>
                </div>
                <div class="bottom-conternt bottom-conternttwo">
                  <a
                    class="nectar-post-grid-link"
                    href="https://www.youtube.com/watch?v=qiIJAW39RdE"
                    aria-label="AI can be beneficial for the marketing process"
                  >
                    <img
                      class="bottom-img"
                      src="../assets/2024/05/图片1.png"
                      alt=""
                    />
                    <div style="padding: 0px 20px" class="huipostrive">
                      <p class="bigsize">CSI Podcast on Deconstructing Data</p>
                      <span class="meta-date">July 13, 2024</span>
                      <p class="text-overhidden">
                        Paul Boynton of CSI joins BDEX for a podcast on<br />
                        1. Sourcing Data: Obtaining Information Categories<br />
                        2. Enriching Data: Industry ...<br />
                      </p>
                      <div class="huisostion">
                        <span class="huibutton">Company News & Blogs</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="bottom-conternt bottom-conternttwo">
                  <a
                    class="nectar-post-grid-link"
                    href="https://financialtechtimes.com/business-decisions-data-solutions-csi/"
                    aria-label="AI can be beneficial for the marketing process"
                  >
                    <img
                      class="bottom-img"
                      src="../assets/2024/05/图片2.png"
                      alt=""
                    />
                    <div style="padding: 0px 20px" class="huipostrive">
                      <p class="bigsize">
                        Article on CSI: Future-Proofing Business Decisions with
                        New Data Solutions from CSI
                      </p>
                      <span class="meta-date">July, 2024</span>
                      <p class="text-overhidden">
                        Financial Tech Times published an article about CSI,
                        Co-Founder Paul Boynton comments ...
                      </p>
                      <div class="huisostion">
                        <span class="huibutton huibuttonabsolute"
                          >Company News & Blogs</span
                        >
                      </div>
                    </div>
                  </a>
                </div>
                <div class="bottom-conternt bottom-conternttwo">
                  <a
                    class="nectar-post-grid-link"
                    href="https://www.infoworld.com/article/2515702/7-reasons-analytics-and-ml-fail-to-meet-business-objectives.html"
                    aria-label="AI can be beneficial for the marketing process"
                  >
                    <img
                      class="bottom-img"
                      src="../assets/2024/05/图片3.png"
                      alt=""
                    />
                    <div style="padding: 0px 20px" class="huipostrive">
                      <p class="bigsize">
                        CSI featured in InfoWorld: 7 reasons analytics and ML
                        fail to meet business objectives
                      </p>
                      <span class="meta-date">July 15, 2024</span>
                      <p class="text-overhidden">
                        Paul Boynton Co-Founder and COO of CSI is featured in a
                        trending article about Machine Learning.
                      </p>
                      <div class="huisostion">
                        <span class="huibutton">Company News & Blogs</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="bottom-conternt bottom-conternttwo">
                  <a
                    class="nectar-post-grid-link"
                    href="#applelogin"
                    aria-label="AI can be beneficial for the marketing process"
                  >
                    <img
                      class="bottom-img"
                      src="../assets/2024/05/截屏2024-08-02 16.38.17.png"
                      alt=""
                    />
                    <div style="padding: 0px 20px">
                      <p class="bigsize">
                        CSI launches Apple and Google compatible apps
                      </p>
                      <span class="meta-date">July 11, 2024</span>
                      <p class="text-overhidden">
                        CSI launches mobile apps compatible with Apple IOS and
                        Google Android. These apps provide easy to use
                        functionality for ...
                      </p>

                      <div class="huisostion">
                        <span class="huibutton huibuttonabsolute"
                          >Company News & Blogs</span
                        >
                      </div>
                    </div>
                  </a>
                </div>
               
              </div> -->
              <swipertwo></swipertwo>

            </el-tab-pane>
            <el-tab-pane label="Webinars" name="Webinars">
              <div class="bottom-conternt">
                <div class="bottom-img"></div>
                <!-- <img class="bottom-img" src="../assets/2024/04/BI-768x494.jpg" alt=""> -->
                <div style="padding: 0px 20px">
                  <p class="bigsize">Test Blog</p>
                  <div>
                    <span class="huibutton">Webinars</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <router-view></router-view>
    </div>

    <div class="about-boxtree">
      <div class="flex-just-sapce">
        <div class="bout-boxtree-left" v-show="scrollHeight > 5200 || $route.name != 'Index'">
          <p class="foot-titel animate__animated animate__fadeInUp marginbottom24">
            CSI
          </p>
          <li class="foot-li marginbottom24">
            Our data and coverage is your worldwide resource for Business
            Intelligence and Business Analytics!
          </li>
          <p class="foot-titel animate__animated animate__fadeInUp">
            Get in Touch
          </p>
          <p class="lianxi">
            <i class="el-icon-message"></i><a class="link_text"
              href="mailto:request@csibizinfo.com">request@csibizinfo.com</a>
          </p>
          <p class="lianxi">
            <i class="el-icon-phone"></i><a class="link_text" href="tel:+4695785630">+ 469-578-5630</a>
          </p>
          <p class="lianxi fa-linkedin-square">
            <svg t="1721981980091" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="5507" width="20" height="20">
              <path
                d="M919.256686 0 104.686849 0C46.922746 0 0 46.866281 0 104.743314l0 814.569837c0 57.820568 46.866281 104.686849 104.686849 104.686849L919.256686 1024c57.820568 0 104.686849-46.696884 104.686849-104.686849L1023.943535 104.743314C1024.056465 46.866281 977.190185 0 919.256686 0zM220.045658 118.803198c56.634795 0 102.484698 42.010256 102.484698 93.732561 0 51.609374-45.849904 93.619631-102.484698 93.619631S117.560959 264.145134 117.560959 212.53576C117.448029 160.813455 163.467328 118.803198 220.045658 118.803198zM332.807058 905.309733 107.284257 905.309733 107.284257 378.035842l225.522801 0L332.807058 905.309733zM905.479129 902.712324l-171.259553 0 0-281.141219c0-55.844279-37.380094-104.799779-97.233416-104.799779-59.909788 0-81.761897 45.624042-81.761897 88.368348 0 57.651172 0 297.629115 0 297.629115L383.908244 902.76879 383.908244 380.576785l171.316019 0 0 77.30113c24.78831-34.952082 87.803695-78.938627 154.828122-78.938627 83.512324 0 100.677805 16.205569 135.121698 50.536532 65.330466 65.386931 59.232203 156.747946 60.192115 184.585387l0.169396 0L905.479129 902.712324z"
                p-id="5508" fill="#ffffff"></path>
            </svg>
            <a class="link_text" href="https://www.linkedin.com/company/company-search-csi/">Linkedin</a>
          </p>

          <p id="applelogin">
            <a href="https://play.google.com/store/apps/details?id=com.csiInc.csiapp&pcampaignid=web_share">
              <img src="../assets/2024/04/googlestorewht.png" alt="" style="margin-right: 10px; opacity: 0.7" /></a>

            <a href="https://apps.apple.com/us/app/csi-search-business-intel/id6478509961">
              <img style="opacity: 0.7" src="../assets/2024/04/applestorewht.png" alt="" />
            </a>
          </p>
        </div>
        <div class="bout-boxtree-right flex-just-sapce">
          <div v-show="scrollHeight > 5200 || $route.name != 'Index'">
            <p class="foot-titel animate__animated animate__fadeInUp marginbottom24">
              Use Cases
            </p>
            <li class="foot-li" @click="scrollToAnchortwo('#Card', 3)">
              Business Intelligence
            </li>
            <li class="foot-li" @click="scrollToAnchortwo('#Card', 4)">
              Business Analysis
            </li>
            <li class="foot-li" @click="scrollToAnchortwo('#Card', 5)">
              Vendor Screening
            </li>
            <li class="foot-li" @click="scrollToAnchortwo('#Card', 6)">KYC</li>
            <li class="foot-li" @click="scrollToAnchortwo('#Card', 7)">
              Ownership Penetration
            </li>
            <li class="foot-li" @click="scrollToAnchortwo('#Card', 14)">
              Credit Assessment
            </li>
            <li class="foot-li">Global Trade</li>
            <li class="foot-li" @click="scrollToAnchortwo('#Card', 10)">
              Legal
            </li>
            <li class="foot-li" @click="scrollToAnchortwo('#Card', 11)">
              Marketing
            </li>
            <li class="foot-li" @click="scrollToAnchortwo('#Card', 12)">
              Industry Analysis
            </li>
            <li class="foot-li" @click="scrollToAnchortwo('#Card', 15)">
              News & Sanctions
            </li>
          </div>
          <div v-show="scrollHeight > 5200 || $route.name != 'Index'">
            <p class="foot-titel animate__animated animate__fadeInUp marginbottom24">
              Resources
            </p>
            <li class="foot-li" @click="$router.push({ name: 'Index', hash: '#Insightstree' })">
              Insights
            </li>
            <li class="foot-li" @click="$router.push({ name: 'Index', hash: '#Insightstwo' })">
              Company News & Blogs
            </li>
            <li class="foot-li" @click="$router.push({ name: 'Index', hash: '#Insights' })">
              Webinars
            </li>
          </div>
          <div v-show="scrollHeight > 5200 || $route.name != 'Index'">
            <p class="foot-titel animate__animated animate__fadeInUp marginbottom24">
              Company
            </p>
            <li class="foot-li" @click="$router.push({ name: 'about', hash: '#top' })">
              About us
            </li>
            <li class="foot-li" @click="$router.push({ name: 'about', hash: '#Purpose' })">
              Our Purpose
            </li>
            <li class="foot-li" @click="$router.push({ name: 'about', hash: '#Team' })">
              Our Team
            </li>
            <li class="foot-li">

              <a style="color: #ffffff" href="mailto:request@csibizinfo.com">Join us</a>
            </li>
          </div>
        </div>
      </div>
      <div style="padding: 20px 0px">
        <p class="flex-just-sapce">
          <span style="font-family: 'Alegreya Sans' !important;">Copyright 2026 Company Search, Inc. All Rights
            Reserved.</span>
          <span class="mobile-footer"><span style="margin-right: 50px;font-family: 'Alegreya Sans' !important;"
              class="hvr-underline-from-right hvr-underline-from-lefrhui" @click="gotoarticle('terms')">Terms &
              Conditions</span><span style="font-family: 'Alegreya Sans' !important;"
              class="hvr-underline-from-right hvr-underline-from-lefrhui"
              @click="gotoarticle('privacy-policy/')">Privacy
              Policy</span></span>
        </p>
      </div>
    </div>

    <el-drawer title="" :visible.sync="drawer" :with-header="false" size="300px" direction="rtl" :show-close="true"
      :wrapperClosable="true" :append-to-body="true">
      <transition name="fade" :duration="400">
        <div class="mobilemenu">
          <svg t="1721896889774" @click="drawer = false" class="icon moblieicon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="16569" width="25" height="25">
            <path
              d="M96 160h832c19.2 0 32 12.8 32 32s-12.8 32-32 32h-832c-19.2 0-32-12.8-32-32s12.8-32 32-32z m0 320h832c19.2 0 32 12.8 32 32s-12.8 32-32 32h-832c-19.2 0-32-12.8-32-32s12.8-32 32-32z m0 320h832c19.2 0 32 12.8 32 32s-12.8 32-32 32h-832c-19.2 0-32-12.8-32-32s12.8-32 32-32z"
              fill="#ffffff" p-id="16570"></path>
          </svg>

          <el-menu :default-active="activeIndex" :active-text-color="'#fff'" background-color="transparent"
            menu-trigger="hover" :text-color="'#fff'" active-color="transparent" style="height: 70px; border: 0"
            :unique-opened="true" @select="handleSelect">
            <el-submenu index="2" :hide-timeout="1000" popper-class="elmenuitem" class="header-title">
              <template slot="title"><span class="header-title" :class="activeIndex != '2'
                  ? scrollTopbg
                    ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                    : 'hvr-underline-from-left hvr-underline-from-leftwrite'
                  : ''
                ">Products</span></template>
              <el-menu-item index="2-1" class="header-titleitem hvr-underline-from-left hvr-underline-from-leftwrite"
                @click="scrollToAnchor('#BusinessIntelligence')"><span>Business Intelligence (BI)</span></el-menu-item>
              <el-menu-item index="2-2" class="header-titleitem hvr-underline-from-left hvr-underline-from-leftwrite"
                @click="scrollToAnchor('#BusinessAnalytics')"><span>Business Analytics (BA)</span></el-menu-item>
              <el-menu-item index="2-3" class="header-titleitem hvr-underline-from-left hvr-underline-from-leftwrite"
                @click="scrollToAnchor('#BusinessCredit')"><span>Business Credit Reports</span></el-menu-item>
              <el-menu-item index="2-4" class="header-titleitem hvr-underline-from-left hvr-underline-from-leftwrite"
                @click="scrollToAnchor('#DataService')"><span>Data Service</span></el-menu-item>
            </el-submenu>
            <el-submenu index="3" :hide-timeout="1000" popper-class="elmenuitem" class="header-title">
              <template slot="title"><span class="header-title" :class="activeIndex != '3'
                  ? scrollTopbg
                    ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                    : 'hvr-underline-from-left hvr-underline-from-leftwrite'
                  : ''
                ">Solutions</span></template>
              <el-menu-item index="3-1" @click="scrollToAnchortwo('#Card', 1)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">Business Intelligence
                  </span>
                </div>
              </el-menu-item>
              <el-menu-item index="3-2" @click="scrollToAnchortwo('#Card', 6)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">Financial Overview</span>
                </div>
              </el-menu-item>
              <el-menu-item index="3-3" @click="scrollToAnchortwo('#Card', 11)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">Market Research</span>
                </div>
              </el-menu-item>

              <el-menu-item index="3-4" @click="scrollToAnchortwo('#Card', 2)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">Business Analytics
                  </span>
                </div>
              </el-menu-item>
              <el-menu-item index="3-5" @click="scrollToAnchortwo('#Card', 7)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">Examine
                    Import-Export</span>
                </div>
              </el-menu-item>
              <el-menu-item index="3-6" @click="scrollToAnchortwo('#Card', 12)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">Credit Assessment</span>
                </div>
              </el-menu-item>
              <el-menu-item index="3-7" @click="scrollToAnchortwo('#Card', 3)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">Vendor Screening
                  </span>
                </div>
              </el-menu-item>
              <el-menu-item index="3-8" @click="scrollToAnchortwo('#Card', 8)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">Legal
                  </span>
                </div>
              </el-menu-item>
              <el-menu-item index="3-9" @click="scrollToAnchortwo('#Card', 13)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">News
                  </span>
                </div>
              </el-menu-item>
              <el-menu-item index="3-10" class="header-titleitem flex-center" @click="scrollToAnchortwo('#Card', 4)">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">KYC
                  </span>
                </div>
              </el-menu-item>
              <el-menu-item index="3-11" @click="scrollToAnchortwo('#Card', 9)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">Marketing
                  </span>
                </div>
              </el-menu-item>
              <el-menu-item index="3-12" @click="scrollToAnchortwo('#Card', 14)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">Sanctions
                  </span>
                </div>
              </el-menu-item>
              <el-menu-item index="3-13" @click="scrollToAnchortwo('#Card', 5)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">Ownership
                    Penetration</span>
                </div>
              </el-menu-item>
              <el-menu-item index="3-14" @click="scrollToAnchortwo('#Card', 10)" class="header-titleitem flex-center">
                <div>
                  <span class="flex-item hvr-underline-from-left hvr-underline-from-leftwrite">Industry Analysls</span>
                </div>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="4" class="mobile-header" @click="scrollToAnchor('#Whoweserve')"><span :class="activeIndex != '4'
                ? scrollTopbg
                  ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                  : 'hvr-underline-from-left hvr-underline-from-leftwrite'
                : ''
              ">Who we serve</span></el-menu-item>
            <!--   hvr-underline-from-left -->
            <el-submenu index="5" popper-class="elmenuitem" class="header-title" :hide-timeout="1000">
              <template slot="title"><span class="header-title" :class="activeIndex != '5'
                  ? scrollTopbg
                    ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                    : 'hvr-underline-from-left hvr-underline-from-leftwrite'
                  : ''
                ">Resources</span></template>
              <el-menu-item index="5-1" @click="scrollToAnchor('#Insights')"
                class="header-titleitem hvr-underline-from-left hvr-underline-from-leftwrite">Insights</el-menu-item>
              <el-menu-item index="5-2" @click="scrollToAnchor('#Insights')"
                class="header-titleitem hvr-underline-from-left hvr-underline-from-leftwrite">Company News &
                Blogs</el-menu-item>
              <el-menu-item index="5-3" @click="scrollToAnchor('#Insights')"
                class="header-titleitem hvr-underline-from-left hvr-underline-from-leftwrite">Webinars</el-menu-item>
            </el-submenu>
            <el-menu-item index="6" class="mobile-header"><span :class="activeIndex != '6'
                ? scrollTopbg
                  ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                  : 'hvr-underline-from-left hvr-underline-from-leftwrite'
                : ''
              ">About us</span>
              <!-- hvr-underline-from-left -->
            </el-menu-item>
            <el-menu-item index="7" class="mobile-header"><span :class="activeIndex != '8'
                ? scrollTopbg
                  ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                  : 'hvr-underline-from-left hvr-underline-from-leftwrite'
                : ''
              " @click="register('csi')">csibizsearch Search</span>
              <!-- hvr-underline-from-left -->
            </el-menu-item>
            <el-menu-item index="8" class="mobile-header"><span :class="activeIndex != '8'
                ? scrollTopbg
                  ? 'hvr-underline-from-left  hvr-underline-from-leftwrite'
                  : 'hvr-underline-from-left hvr-underline-from-leftwrite'
                : ''
              " @click="register('udm')">
                udmrnd Search</span>
              <!-- hvr-underline-from-left -->
            </el-menu-item>
          </el-menu>
        </div>
      </transition>
    </el-drawer>

    <!-- <div style="width: 100%;margin: 20px auto;">
            <div style="height:1px;padding:0;background-color:#999;">
            </div>
        </div> -->
    <div style="width: 100%"></div>
  </div>
</template>

<script>
import swiper from "../components/swiper.vue";
import swipertwo from '../components/swipertwo.vue';
import swipertree from '../components/swipertree.vue';
import countTo from "vue-count-to";
import Swiper from "swiper"; // 注意引入的是Swiper
import "swiper/css/swiper.min.css"; // 注意这里的引入
import "animate.css";
export default {
  directives: {
    scroll: {
      inserted(el, binding) {
        const handleScroll = binding.value;
        el.addEventListener("scroll", handleScroll);
      },
      unbind(el, binding) {
        const handleScroll = binding.value;
        el.removeEventListener("scroll", handleScroll);
      },
    },
  },

  name: "Layout",
  components: { countTo, swiper, swipertwo, swipertree },
  watch: {
    "$route.hash": function () {
      // console.log(`this.$route.hash`,this.$route.hash );
      this.scrollToAnchortree();
      // 在这里可以处理hash变化后的逻辑
      // this.scrollToAnchor();
    },
  },
  data() {
    return {
      OurDataEngineeringishow: false,
      OurDatafalse: false,
      echartsfalse: false,
      echartstwofalse: false,
      echarts3false: false,
      echarts4false: false,
      echarts5false: false,
      echarts6false: false,
      echarts7false: false,
      swiper: null,
      swipertwo: null,
      swipertree: null,
      drawer: false,
      activeIndex: "1",
      duration: 2500,
      // 初始值
      startVal: 0,
      starttop: 838,
      // 最终值
      endVal: 500,
      activeName: "Insights",
      company: {
        qrcode: require("../../static/other/公众号二维码.jpg"),
      },
      organizationsimgs: [
        {
          title: "Financial Institutions",
          img: require("../assets/2023/10/fpi-300x300.jpg"),
        },
        {
          title: "Insurance",
          img: require("../assets/2023/10/insurance-300x300.jpg"),
        },
        {
          title: "Investment Management",
          img: require("../assets/2023/10/investment-300x300.jpg"),
        },
        {
          title: "Manufacture",
          img: require("../assets/2023/10/manufacture-300x300.jpg"),
        },
        {
          title: "Trade",
          img: require("../assets/2023/10/trade-300x300.jpg"),
        },
        {
          title: "Professional Services",
          img: require("../assets/2023/10/prof-services-300x300.jpg"),
        },
        {
          title: "Ecommerce",
          img: require("../assets/2023/10/ecommerce-300x300.jpg"),
        },
        {
          title: "Data Management",
          img: require("../assets/2023/10/data-management-300x300.jpg"),
        },
        {
          title: "Education",
          img: require("../assets/2023/10/education-300x300.jpg"),
        },
        {
          title: "Organization",
          img: require("../assets/2023/10/organization-300x300.jpg"),
        },
      ],
      organizationsimgstwo: [
        {
          title: "Business Intelligence",
          li: [
            "Public and Private Companies Revealed",
            "Confirm customer and vendor legitimacy",
            "Check operational and regulatory status",
            "Examine the ownership and management",
            "Evaluate financial performance and metrics",
            "Assess market position and compare to peers",
            "Investigate for sanctions embargo or penalties",
          ],
          img: require("../assets/2023/10/1Business-Intelligence.gif"),
        },
        {
          title: "Business Analytics",
          li: [
            "AI organized Intelligence",
            "Financial highlights and metrics",
            "Performance metrics",
            "Credit rating and opinion",
            "Industry and marketplace benchmarking",
            "Compare to industry peers",
            "ESG rating",
          ],

          img: require("../assets/2023/10/2Business-Analytics.gif"),
        },
        {
          title: "Vendor Screening",
          li: [
            "Standards and Compatibility",
            "Registration records",
            "Confirm operational history",
            "Legal records",
            "Review management",
            "Ownership and related entities",
            "tudy supply chain compatibility",
          ],

          img: require("../assets/2023/10/3Vendor-Screening.gif"),
        },
        {
          title: "KYC",
          id: "KYC",
          li: [
            "Confirm registration and operational status",
            "Review financial performance and analytics",
            "Credit rating and opinion",
            "Analyze through layers of ownership",
            "Research supply chain for compatibility",
            "Benchmark for industry, product and market",
            "Capture relevant news on company and industry",
            "Check Sanctions records for embargos or penalties.",
          ],

          img: require("../assets/2023/10/4KYC.gif"),
        },
        {
          title: "Ownership Penetration",
          li: [
            "A behind the curtain review of owners and affiliates",
            "View ownership structure",
            "Understand affiliated entities",
            "Perform full KYC review of owners",
            "Dive into and chart ownership layers",
          ],

          img: require("../assets/2023/10/5Ownership-Penetration.gif"),
        },
        {
          title: "Financial Overview",
          li: [
            "Analyze Financial performance and metrics",
            "Review financial data, balance sheet, P&amp;",
            "Follow historical financial results",
            "Contrast with peers",
            "Measure market status",
            "Monitor performance",
          ],

          img: require("../assets/2023/10/6Financial-Overview.gif"),
        },
        {
          title: "Examine Import-Export",
          li: [
            "Analyze Import and Export records",
            "Review Supply Chain for compatibility",
            "Identify vulnerabilities and possible disruption",
            "Evaluate geopolitical factors",
            "Review product line and market and identity KPI's",
            "Check sanctions manifest",
          ],

          img: require("../assets/2023/10/7Examine-Import-Export.gif"),
        },
        {
          title: "Legal",
          li: [
            "Verify company identification",
            "Review registration records",
            "Incorporation and operational history",
            "Ownership Structure",
            "Family Tree",
            "anctions",
            "Legal publications",
          ],

          img: "",
        },
        {
          title: "Marketing",
          li: [
            "Qualify and find prospects",
            "Lead generation database",
            "Research by Industry, financial size and results, Geography, Product or Market",
          ],

          img: require("../assets/2023/10/9Marketing.gif"),
        },
        {
          title: "Industry Analysis",
          li: [
            "Identify opportunities and threats",
            "Know the competitive landscape",
            "Study market trends and behavior",
          ],

          img: require("../assets/2023/10/10Industry-Analysis.gif"),
        },
        {
          title: "Market Research",
          li: [
            "Product source and end users",
            "Data for SWOT analysis",
            "Country analysis",
            "Economic trends",
            "Demographic analysis identify targets",
            "Benchmarking",
          ],

          img: require("../assets/2023/10/11Market-Research.gif"),
        },
        {
          title: "Credit Assessment",
          li: [
            "Creditworthiness and default opinion",
            "Investment quality",
            "Assess financial stability",
            "Review and monitor ratings",
          ],

          img: require("../assets/2023/10/12Credit-Assessment.gif"),
        },
        {
          title: "News",
          li: [
            "Leading media partners provide current news on: companies, industries, countries, relevant products, markets and economy",
          ],
          img: "",
        },
        {
          title: "Sanctions",
          li: [
            "Check Sanctions Worldwide Listings for:",
            "Trade Sanctions.",
            "Travel Sanctions on management.",
            "Diplomatic Sanctions",
            "Operational Disruptions",
            "Market Access",
            "Legal, Financial, Reputational consequences",
          ],
          img: "",
        },
      ],
      UseCases: [
        "Business Intelligence",
        "Business Analysis",
        "Vendor Screening",
        "KYC",
        "Ownership Penetration",
        "Creadit Assessment",
        "Global Trade",
        "Legal",
        "Marketing",
        "Industry Analysis",
        "News & Sanctions",
      ],
      Resources: [
        "Insights",
        "Business Analysis",
        "Company News & Blogs",
        "Webinars",
      ],
      // Company:['Insights','Business Analysis','Company News & Blogs','Webinars'],

      scroll: "",
      timer: "",
      seen: true,
      screenWidth: 1300,
      currentMenu: "首页",
      highlightedIndex: null,
      scrollTopbg: true,
      scrollHeight: 0,
      mobile: false,
      imgmobile: false,
      value: "",
    };
  },
  methods: {
    scrollToAnchortree() {
      const el = document.querySelector(this.$route.hash);

      el.scrollIntoView({ behavior: "smooth" });
    },
    handleScroll() {
      // this.scrollHeight= document.documentElement.scrollHeight;
      const scrollTop = this.scrollHeight =

        document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight;
      const rect = this.$refs.OurDataEngineering.getBoundingClientRect();

      const topPosition = rect.top; // 相对于视口的顶部位置
      const elementTopRelativeToDocument = topPosition + scrollTop
      this.starttop = clientHeight + scrollTop

      this.OurDatafalse = this.starttop > this.$refs.OurData.getBoundingClientRect().top + scrollTop + 50;
      this.echartsfalse = this.starttop > this.$refs.echarts.getBoundingClientRect().top + scrollTop + 50;
      this.echartstwofalse = this.starttop > this.$refs.echartstwo.getBoundingClientRect().top + scrollTop + 50;
      this.echarts3false = this.starttop > this.$refs.echarts3.getBoundingClientRect().top + scrollTop + 50;
      this.echarts4false = this.starttop > this.$refs.echarts4.getBoundingClientRect().top + scrollTop + 50;
      this.echarts5false = this.starttop > this.$refs.echarts5.getBoundingClientRect().top + scrollTop + 50;
      this.echarts6false = this.starttop > this.$refs.echarts6.getBoundingClientRect().top + scrollTop + 50;

      this.OurDataEngineeringishow = this.starttop > elementTopRelativeToDocument




      // 处理滚动事件
      // 获取页面高度示例
      const scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollTopbg = scrollHeight == 0;
      if (this.scrollTopbg) {
        // window.scrollTo(0, 10);
      }
    },

    initPic(text, obj, num, color, left, x) {
      const myChart = this.$echarts.init(obj);
      let data = num;

      let option = {
        title: {
          subtext: text,
          //  text: num=='n.a.'?'n.a.':'',
          // left: left,
          top: num == "n.a." ? "68%" : "75%",
          left: "20%",
          // x: 'center',
          //  y: 'center',
          textStyle: {
            fontWeight: "normal",
            fontSize: 16,
            color: "#8497AB",
            // align: 'center',
            // left: 'center',
          },
          subtextStyle: {
            fontSize: 16,
            color: "#022955",
            // fontWeight: '300',
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{d}%",
          show: true,
        },
        legend: {
          top: 20,
          right: 20,
        },

        series: [
          {
            type: "pie",
            // 圆环大小粗细
            radius: ["50%", "59.5%"],
            center: [x, left],
            avoidLabelOverlap: false,
            hoverAnimation: false,

            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: data,
                itemStyle: {
                  // color: ,
                  color: color,
                  // colorStops: data.ringColor
                },
                // name: 'Data Quality',
              },
              {
                value: 100 - data,
                itemStyle: {
                  color: "#E9EEF4",
                },
                // name: 'Credit Score',
              },
            ],
          },
          {
            type: "pie",

            radius: ["50%", "59.5%"],
            center: [x, left],
            avoidLabelOverlap: false,
            hoverAnimation: false,

            labelLine: {
              normal: {
                show: false,
              },
            },

            data: [
              {
                value: data,
                itemStyle: {
                  color: color,
                },
                // name: 'Data Quality',
              },
              {
                value: 100 - data,

                itemStyle: {
                  color: "#cccccc",
                },
                // name: 'Credit Score',
              },
            ],
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // getSwiper() {
    //   this.swiper = new Swiper(".resource-container", {
    //     loop: false, // 无缝
    //     // autoplay: { //自动开始
    //     //     delay: 3000, //时间间隔
    //     //     disableOnInteraction: false, //*手动操作轮播图后不会暂停*
    //     // },
    //     paginationClickable: true,
    //     slidesPerView: 6, // 一组三个
    //     spaceBetween: 20, // 间隔
    //     // 如果需要前进后退按钮
    //     navigation: {
    //       nextEl: ".swiper-button-next",
    //       prevEl: ".swiper-button-prev",
    //     },
    //     // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
    //     observer: true,
    //     observeParents: true,
    //     // 如果需要分页器
    //     pagination: {
    //       el: ".swiper-pagination",
    //       clickable: true, // 分页器可以点击
    //     },
    //   });
    // },
    //多图轮播
    getswipert() {
      this.swipertwo = new Swiper(".swiper-Solutions", {
        loop: true, // 禁用无缝循环
        //设置为true则点击slide会过渡到这个slide。
        slideToClickedSlide: true,
        centeredSlides: true,
        //居中幻灯片无缺口。当你通过设置 centeredSlides: true 使得幻灯片居中后，
        centeredSlidesBounds: true,
        // 这个参数可以使你的活动块（active slide）指示为最左边的那个slide（当没开启 centeredSlides 时）
        normalizeSlideIndex: false,

        // centerInsufficientSlides:true,  // 当slides 的总数小于 slidesPerView 时，slides居中
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        // paginationClickable: true,

        slidesPerView: this.mobile ? 1 : 3,
        // slidesPerGroup: 1, // 每次滑动1个数据
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        //         navigation: {
        //          nextEl: '.swiper-button-nex',
        // prevEl: '.swiper-button-pre',
        //     },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets", // 使用圆点分页器
          clickable: true,
        },
      });
    },
    handleClick() { },

    // 定位
    scrollToAnchor(anchor) {
      if (this.screenWidth < 1200) {
        this.drawer = false;
      }
      if (this.$route.name != "Index") {
        this.$router.push({ name: "Index" });
      }
      const el = document.querySelector(anchor);
      el.scrollIntoView({ behavior: "smooth" });
    },
    scrollToAnchortwo(anchor, adcIdex) {
      if (this.screenWidth < 1200) {
        this.drawer = false;
      }
      // var clickedIndex = this.swipertwo.clickedIndex;
      // console.log("当前展示的数据的索引是：" + activeIndex);
      if (this.$route.name != "Index") {
        this.$router.push({ name: "Index" });
      }
      const el = document.querySelector(anchor);
      el.scrollIntoView({ behavior: "smooth" });
      this.swipertwo.slideTo(adcIdex);
    },
    handleSelect(key) {
      if (this.screenWidth < 1200) {
        this.drawer = false;
      }
      this.activeIndex = key;
      switch (key) {
        case "1":
          this.$router.push({ name: "Index" });
          break;
        case "2":
          this.$router.push({ name: "Products" });
          window.location.hash = "#Products";
          break;

        case "3":
          this.$router.push({ name: "solutions" });
          window.location.hash = "#solutions";
          break;
        case "4":
          this.$router.push({ name: "Index" });
          window.location.hash = "#Whoweserve";
          break;
        case "5":
          this.$router.push({ name: "Index" });
          window.location.hash = "#Index";
          break;
        case "6":
          this.$router.push({ name: "about" });
          window.location.hash = "#top";
          break;
      }
    },
    handleSelectMobile(key) {
      switch (key) {
        case "1":
          this.$router.push({ name: "Index" });
          break;
        case "2":
          this.$router.push({ name: "Products" });
          window.location.hash = "#Products";
          break;

        case "3":
          this.$router.push({ name: "solutions" });
          window.location.hash = "#solutions";
          break;
        case "4":
          this.$router.push({ name: "Index" });
          window.location.hash = "#Whoweserve";
          break;
        case "5":
          this.$router.push({ name: "Index" });
          window.location.hash = "#Index";
          break;
        case "6":
          this.$router.push({ name: "about" });
          window.location.hash = "#about";
          break;
      }
    },
    // handleScroll() {
    //   this.scroll =
    //     document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
    //   if (this.scroll > 600) {
    //     //判断滚动后高度超过400px,就显示
    //     this.$refs.btn.style.display = "block";
    //   } else {
    //     this.$refs.btn.style.display = "none";
    //   }
    // },
    backTop() {
      //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部

      this.timer = setInterval(() => {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(this.timer);
        }
      }, 30);
    },

    register(url) {
      if (url == "udm") {
        window.open("https://www.udmrnd.com/#/");
      } else {
        window.open("https://csibizsearch.com/#/");
      }
    },
    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;
      this.screenWidth = document.body.clientWidth;

      if (screenHeight > 1200) {
        this.seen = true;
        console.log(`11`, 11);
        this.mobile = false;

        this.getswipert();
        this.craedit();
      } else {
        this.seen = false;
        if (screenHeight < 1000) {
          this.mobile = true;
          // if(screenHeight == 1000){
          this.getswipert();
          if (screenHeight < 600) {
            this.imgmobile = true;
          } else {
            this.imgmobile = false;
          }
          // }
        }
      }
    },
    logoClick() {
      this.$router.push({ name: "Index" });
      this.currentMenu = "首页";
    },
    typeWriter() { },
    gotoarticle(route) {
      this.$router.push({ name: route });
      // window.location.hash = "#about#top";
    },
    craedit() {
      this.initPic("", this.$refs.dataQuality, 97, "#d87b36", "50%", "48%");
      this.initPic("", this.$refs.dataQuality1, 85, "#d87b36", "50%", "48%");

      this.initPic("", this.$refs.dataQuality5, 89, "#d87b36", "50%", "48%");
      this.initPic("", this.$refs.dataQuality6, 94, "#d87b36", "50%", "48%");
      this.initPic("", this.$refs.dataQuality7, 90, "#d87b36", "50%", "48%");
      this.initPic("", this.$refs.dataQuality8, 99, "#d87b36", "50%", "48%");
      this.initPic("", this.$refs.dataQuality9, 75, "#d87b36", "50%", "48%");
    },
  },
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {
    this.craedit();
    // this.scrollToAnchortree()
    window.addEventListener("resize", this.menuSeen);
    this.menuSeen();
    // this.getSwiper();
    this.getswipert();

    // 字体动态效果

    if (this.$route.query.Form == 'Csi') {
      this.scrollToAnchortwo('#Card', 3)
    }

    const textElement4 = document.querySelector(".step4");
    let strings = ["Focus", "Verify", "Analyze", "Quantify", "Rationalize"];
    let stringIndex = 0;
    let charIndex = 0;
    textElement4.innerHTML = "";
    let timerId;
    function typeWriter4() {
      textElement4.classList.add("start");
      if (stringIndex < strings.length) {
        const currentString = strings[stringIndex];
        if (charIndex < currentString.length) {
          textElement4.textContent += currentString.charAt(charIndex);
          charIndex++;
          timerId = setTimeout(typeWriter4, 150); // 设置打字速度
        } else {
          stringIndex++;
          charIndex = 0;
          if (stringIndex < strings.length) {
            textElement4.innerHTML = "";
            timerId = setTimeout(typeWriter4, 400);
          } else {
            clearTimeout(timerId);
            stringIndex = 0;
            charIndex = 0;
            textElement4.innerHTML = "";
            setTimeout(() => {
              typeWriter4();
            }, 3100);
          }
        }
      } else {
        textElement4.classList.remove("start");
      }
    }
    setTimeout(() => {
      typeWriter4();
    }, 4550);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.menuSeen);
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #000000;
}

body {
  font-size: 18px;
}

p {
  font-size: 18px;
}

b {
  font-weight: 400;
}

.logo_img {
  float: left;
  width: 30%;
  cursor: pointer;
}

#back_to_top {
  position: fixed;
  bottom: 50px;
  right: 30px;
  cursor: pointer;
}

.header-title {
  font-size: 16px;
  font-weight: 400 !important;
}

.company_name {
  font-weight: normal;
  font-size: 1em;
}

.footer_font {
  font-size: 1em;
}

#menu_index {
  float: left;
  width: auto;
  height: 100%;
}

.header {
  margin: auto;
  width: 88%;
  height: 65px;
  transition: height 0.6s ease;
  padding-top: 7px;
  transition: padding-top 0.6s ease;
}

.headerbg {
  margin: auto;
  width: 88%;
  height: 75px;
  transition: height0.6s ease;
  padding-top: 20px;
  transition: padding-top 0.6s ease;
}

.header-fixde {
  position: fixed;
  z-index: 999;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);

  transition: background-color 0.6s ease;
}

.header-fixdebg {
  position: fixed;
  z-index: 999;
  width: 100%;
  background-color: transparent;

  transition: background-color 0.6s ease;
  /* 与
   

  /* box-shadow: 0 0 30px rgba(0, 0, 0, 0.2); */
}

@media (max-width: 1200px) {
  .video-content-title {
    width: 400px !important;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1800px) {
  .ecahrt {
    position: relative;
    scale: 1.3 !important;
    /* left: 50%; */
  }
}

@media screen and (min-width: 600px) and (max-width: 1100px) {
  .nectar-video-inner {
    width: 100%;
    position: relative;
    height: 800px !important;
    /* height: 100%; */
  }

  .row-bg-layer {
    position: absolute;
    width: 100%;
    height: 800px !important;
    /* height: 100%; */
    z-index: 9;
  }

  .logo_img {
    float: left;
    width: auto;
    cursor: pointer;
  }

  #header-img {
    width: 150px;
    height: 24px;
  }

  /* height: 100% !important;
    width: 100% !important; */
  #back_to_top {
    position: fixed;
    bottom: 50px;
    right: 5px;
    cursor: pointer;
  }

  .footer_font {
    font-size: 0.875em;
  }

  #menu_index {
    float: right;
    width: auto;
    height: 100%;
  }

  .mobile_menu {}

  .one-wrapper {
    flex-wrap: wrap;
  }

  .bg-count {
    flex-wrap: wrap;
  }

  .flex-just-sapce {
    flex-wrap: wrap;
  }

  .soction-slide {
    overflow: hidden;
  }

  .flex-right img {
    width: 100% !important;
    height: 452px !important;
  }

  .bottom-conternt {
    width: 32% !important;
  }

  .about-box-bottom .flex-just-sapce {
    justify-content: center !important;
  }

  .bout-boxtree-left {
    width: 100% !important;
  }

  .link_text {
    font-size: 16px !important;
  }

  .flex-left {
    width: 100% !important;
  }

  .mobile-footer {
    margin: 20px 0px;
  }

  h2 {
    font-size: 32.5px !important;
    max-width: 100% !important;
  }

  .symbol-wrap span {
    font-size: 26px;
  }

  .contnum {
    font-size: 49px !important;
  }

  .bg-count {
    padding: 30px 10px !important;
  }

  .video-content-title {
    width: 100% !important;
  }

  .postion {
    position: absolute;
    top: 46% !important;
    right: 25% !important;
    width: 50% !important;
    z-index: 11;
  }

  .video-content-title {
    font-size: 53px !important;
  }

  .start_font {
    font-size: 36px !important;
  }

  .video-content-left {
    left: 20% !important;
    /* text-align: center !important; */
  }

  .seach-icon {
    text-align: left !important;
    margin-left: 6%;
  }

  .resource-slide {
    width: 100% !important;
    margin-right: 0px !important;
  }

  .flex-right {
    width: 100% !important;
  }

  .about-boxtwo {
    padding: 6% 16% !important;
  }

  .about-box {
    margin: 7% 16% !important;
  }

  .Engineering {
    height: auto !important;
  }

  .bigsize {
    font-size: 22px !important;
  }
}

@media (max-width: 600px) {
  .bigsize {
    font-size: 22px !important;
  }

  .Engineering {
    height: auto !important;
  }

  .postion[data-v-005bfc5a] {
    position: absolute;
    top: 66% !important;
    right: 19% !important;
    width: 60% !important;
    z-index: 11;
  }

  .video-content-left {
    left: 0px !important;
    text-align: center !important;
  }

  .nectar-video-inner {
    width: 100%;
    position: relative;
    height: 800px !important;
    /* height: 100%; */
  }

  .row-bg-layer {
    position: absolute;
    width: 100%;
    height: 800px !important;
    /* height: 100%; */
    z-index: 9;
  }

  .logo_img {
    float: left;
    width: auto;
    cursor: pointer;
  }

  #header-img {
    width: 150px;
    height: 24px;
  }

  /* height: 100% !important;
    width: 100% !important; */
  #back_to_top {
    position: fixed;
    bottom: 50px;
    right: 5px;
    cursor: pointer;
  }

  .footer_font {
    font-size: 0.875em;
  }

  #menu_index {
    float: right;
    width: auto;
    height: 100%;
  }

  .mobile_menu {}

  .swiper-pagination {
    bottom: -4px !important;
  }

  .one-wrapper {
    flex-wrap: wrap;
  }

  .bg-count {
    flex-wrap: wrap;
  }

  .flex-just-sapce {
    flex-wrap: wrap;
  }

  .soction-slide {
    overflow: hidden;
  }

  .flex-right img {
    width: 100% !important;
  }

  .bottom-conternt {
    width: 90% !important;
  }

  .bout-boxtree-left {
    width: 100% !important;
  }

  .link_text {
    font-size: 16px !important;
  }

  .flex-left {
    width: 100% !important;
  }

  .mobile-footer {
    margin: 20px 0px;
  }

  .huibuttonabsolute {
    position: inherit !important;
  }

  .isactiveimg {
    display: none;
    height: 152px !important;
    width: 200px !important;
    margin: auto;
    margin-top: 20px;
  }

  h2 {
    font-size: 32.5px !important;
    max-width: 100% !important;
  }

  .symbol-wrap span {
    font-size: 26px;
  }

  .contnum {
    font-size: 49px !important;
  }

  .bg-count {
    padding: 30px 10px !important;
  }

  .video-content-title {
    width: 100% !important;
  }

  .postion {
    position: absolute;
    top: 46% !important;
    right: 25% !important;
    width: 50% !important;
    z-index: 11;
  }

  .video-content-title {
    font-size: 53px !important;
  }

  .start_font {
    font-size: 36px !important;
  }

  .video-content-left {
    left: 20%;
    /* text-align: center !important; */
  }

  .seach-icon {
    text-align: left !important;
    margin-left: 6%;
  }

  .resource-slide {
    width: 100% !important;
    margin-right: 0px !important;
  }

  .flex-right {
    width: 100% !important;
  }

  .about-boxtwo {
    padding: 6% 16% !important;
  }

  .about-box {
    margin: 7% 16% !important;
  }

  .bottom-conternttwo {
    width: 100% !important;
  }
}

#header-img {
  /* width: 162px; */
  height: 30px;
  cursor: pointer;
  margin-top: 8px;
}

.header-logo {
  height: 50px;
  width: 50px;
  align-self: center;
}

/deep/.el-button.is-round {
  border-radius: 5px;
}

/deep/ .el-menu {
  background: transparent;
}

.header-important {
  float: left;
  margin-left: 6px;
  align-self: center;
}

.footer {
  display: flex;
  align-items: center;
  width: 100%;
}

.footer {
  font-family: 'Alegreya Sans' !important;
  width: 100%;
}

.hvr-underline-from-left {
  display: inline-block;
  vertical-align: middle;
  /* -webkit-transform: perspective(1px) translateZ(0); */
  transform: perspective(1px) translateZ(0);
  position: relative;
  overflow: hidden;
  line-height: 27px;
}

.hvr-underline-from-left:before {
  content: "";
  position: absolute;
  z-index: -1;
  left: 0;
  right: 100%;
  height: 2px;
  bottom: 0;
  background: #1290c9;

  -webkit-transition-property: right;
  transition-property: right;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  border: none;
}

.hvr-underline-from-right {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  text-decoration: solid;
  text-decoration-color: #9b9b9b;
  /* -webkit-transform: perspective(1px) translateZ(0); */
  transform: perspective(1px) translateZ(0);
  position: relative;
  overflow: hidden;
  border-bottom: 2px solid #666667;
}

.hvr-underline-from-right:before {
  content: "";
  position: absolute;
  z-index: -1;
  right: 0;
  left: 100%;
  height: 2px;
  bottom: 0;
  background: #1290c9;

  -webkit-transition-property: left;
  transition-property: left;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  border: none;
}

.hvr-underline-from-leftwrite:before {
  background: #fff;
}

.hvr-underline-from-leftblack:before {
  background: #000000;
}

.hvr-underline-from-lefrhui:before {
  background: #cdcdcd;
  cursor: pointer;
}

.hvr-underline-from-leftbluewer {
  color: #1290c9;
  margin-left: 15px;
  font-weight: 500;
  font-size: 18px;
}

.hvr-underline-from-leftbluewer:before {
  background: #1290c9;
  font-size: 18px;
}

.hvr-underline-from-left:hover:before {
  right: 0;
}

.hvr-underline-from-right:hover {
  border-bottom: none;
}

.hvr-underline-from-right:hover:before {
  left: 0;
}

/deep/ .el-menu--horizontal>.el-menu-item.is-active {
  /* border: none; */
  color: #000000 !important;
  height: 58px;
  /* border-bottom: 2px solid #fff; */
  border-bottom-color: transparent !important;
}

.container {
  /* width: 85%; */
  margin: auto;
  font-size: 18px;
}

.nectar-video-inner {
  width: 100%;
  position: relative;
  /* height: 780px; */

  height: 100%;
  max-height: 800px;
}

.row-bg-layer {
  position: absolute;
  width: 100%;
  /* height: 780px; */
  height: 100%;
  max-height: 800px;
  z-index: 9;
}

.video-content {
  z-index: 10;
  width: 100%;
}

.postion {
  position: absolute;
  top: 26%;
  right: 19%;
  width: 25%;
  z-index: 11;
}

.video-content-title {
  font-size: 84px;
  color: #fff;
  margin-bottom: 0px;
  width: 600px;
  margin-top: 12%;
  font-weight: 500 !important;
}

.video-content-left {
  position: absolute;
  top: 13%;
  left: 6%;
  z-index: 11;
}

.start_font {
  font-family: "Alegreya Sans";
  font-size: 84px;
  width: auto;
  color: #1290c9;
  text-align: left;
  font-style: normal;
  position: relative;
  display: inline-block;
  z-index: 10;
  font-weight: 500;
}

.focus {
  position: relative;
}

.wight_bold {
  font-family: "Alegreya Sans";
  color: #1290c9;
}

.el-icon-search {
  font-size: 22px;
  color: #fff;
  font-weight: 400;
  margin-right: 15px;
}

.seach-icon {
  font-size: 18px;
  color: #fff;
  font-weight: 400;
  margin-top: 50px;
}

.about-box {
  margin: 7%;
  padding-top: 20px;
  margin-bottom: 2%;
}

.about-boxtwo {
  padding: 6%;
  padding-bottom: 0px;
  /* padding-top: 20px; */
  background-color: #fff;
}

#DataService {
  padding-bottom: 6%;
}

.container {
  background-color: #f0f2f6;
}

.h2title {
  font-size: 46px;
  color: #000000;
  font-weight: 500 !important;
}

/deep/ .el-submenu.is-active .el-submenu__title {
  border-bottom-color: transparent !important;
}

/deep/ .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus {
  background-color: transparent !important;
}

/deep/ .el-submenu__title i {
  display: none !important;
}

/deep/ .el-button--primary {
  background-color: #1290c9;
  color: #fff;
}

.header-titleitem {
  padding: 10px 26px !important;
  font-size: 12px;
  margin: 5px 0px;
  line-height: 17px !important;
  height: auto !important;
  color: #000000 !important;
}

.titleitem-img {
  height: 35px;
  width: 35px;
  margin-right: 10px;
}

.flex-center {
  display: flex;
  /* flex-wrap: wrap; */
}

.flex-item {
  display: inline-block;
  width: 90px;
}

.block {
  display: flex;
  margin-top: 40px;
}

.img-contern {
  height: 200px;
  width: 200px;
  margin: 0 20px;
}

.flex-just-sapce {
  display: flex;
  justify-content: space-between;

}

.flex-left {
  width: 66%;
}

.flex-right {
  display: flex;
  /* align-items: center; */
  margin-top: 8%;
}

.contert-text {
  font-family: "Roboto" !important;
  font-size: 18px;
  line-height: 32px;
  /* font-weight: 400 !important; */
}

.el-icon-document {
  color: #1290c9;
  height: 20px;
  width: 20px;
}

.iwt-textul {
  font-family: "Roboto";
  font-size: 18px;
  line-height: 32px;
  font-weight: 400;
}

.tex-xiahuaxian {
  background-image: linear-gradient(to right, #1290c9 0, #1290c9 100%);
  background-size: 100% 28% !important;
  background-repeat: no-repeat;
  background-size: 0 80%;
  /* background-image: linear-gradient(to right, #000 0, #000 100%); */
  transition: background-size 0.9s cubic-bezier(0.15, 0.75, 0.4, 1),
    opacity 0.25s ease;
  background-position: left 90%;
}

.title-head {
  font-family: "Alegreya Sans" !important;
  font-size: 28px;
  line-height: 38px;
  font-weight: 400;
  color: #1290c9;
  margin-bottom: 20px;
  margin-top: 20px;
}

/deep/ .el-tabs__item {
  font-size: 32px;
  font-weight: 500;
  color: #9b9b9b;
  margin-bottom: 20px;
  padding-left: 20px !important;
}

/deep/ .el-tabs__active-bar {
  background-color: #1290c9;
  min-width: 150px;
}

/deep/ .el-tabs__item.is-active {
  color: #000000;
}

.bottom-img {
  position: relative;
  width: 102%;
  height: 260px;
  transition: transform 0.42s ease, background-color 0.42s ease;
}

.bottom-conternt {
  position: relative;
  width: 24%;
  background-color: #fff;
  /* font-family: Alegreya Sans; */
  font-size: 18px;
  line-height: 38px;
  padding-bottom: 20px;
  max-width: 370px;
  margin-top: 70px;
  margin-left: 20px;
  margin-bottom: 20px;
  transition: transform 0.42s ease, background-color 0.42s ease;
  overflow: hidden;
}

.bigsize {
  font-size: 28px;
  margin-bottom: 20px;
  display: -webkit-box;
  /* 使用弹性盒模型 */
  -webkit-box-orient: vertical;
  /* 垂直方向排列 */
  -webkit-line-clamp: 2;
  /* 限制为两行 */
  overflow: hidden;
  /* 超出部分隐藏 */
  text-overflow: ellipsis;
  /* 使用省略号表示超出部分 */
  height: 3em;
  /* 设置高度以适应两行文本 */
  line-height: 1.5em;
}

.about-box-bottom {
  margin: 0 5%;
  padding-top: 20px;
  padding-bottom: 8%;
}

.bottom-conternt:hover {
  transform: translateY(-4px);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
  /* box-shadow: 0 30px 60px rgba(0, 0, 0, .15); */
}

.bottom-conternt:hover .bottom-img {
  transform: scale(1.1);
}

.banshi {
  width: 100%;
  margin: 0 auto;
  padding: 30px 0px 10px 0px;
}

.resource-wrapper {
  /* overflow: auto; */
}

.resource-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}

.resource-slide {
  background-repeat: no-repeat;
  background-size: contain;
  text-align: center;
  cursor: pointer;
  margin-right: 20px;
}

/* .resource-slide, */
.swiper-slide {
  position: relative;
  /* height: 291px; */
  width: 211px;
  background-repeat: no-repeat;
  background-size: contain;
  text-align: center;
  cursor: pointer;
}

.el-button {
  z-index: 2;
}

.swiper-button-next,
.swiper-button-prev {
  height: 40px;
  width: 40px;
  background-color: #fff;
  border-radius: 50%;
  color: #000000;
  transition: transform 0.42s ease, background-color 0.42s ease;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  content: "";
}

.swiper-button-next {
  transform: rotateY(180deg);
}

.swiper-button-prev:hover {
  transform: scale(1.2);
}

.soction-slide {
  border-radius: 20px;
  height: 515px;
  padding: 20px;
  font-size: 14px;
  text-align: left;
  background-color: #fff;
  margin-bottom: 17%;
  line-height: 36px;
  overflow: hidden;
}

.soction-slide ul {
  padding-left: 0px;

  line-height: 33px;
}

.soction-slide li {
  margin-left: 40px;
  line-height: 33px;
  font-weight: normal;
}

/deep/ .swiper-pagination-bullet {
  height: 14px;
  width: 14px;
  margin: 0 10px !important;
}

.soction-slide-titel {
  margin: 0px;
  font-size: 30px;
  text-align: center;
  font-weight: 500;
}

.highlighted {
  background-color: #1290c9;
}

/deep/.swiper-slide-active .soction-slide {
  background: #3452ff;
  color: #fff;
}

/deep/.swiper-slide-active .isactiveimg {
  display: block;
}

.isactiveimg {
  display: none;
  height: 192px;
  width: 250px;
  margin: auto;
  margin-top: 20px;
}

.contnum {
  font-size: 62px;
  line-height: 62px;
  font-family: "Open Sans";
  font-weight: 500;
}

.Engineering {
  background-image: url("../assets/2023/10/world-map.jpg");
  /* background-position: center center; */
  /* background-repeat: no-repeat; */
  background-repeat: round;
  background-color: #0069bf;
  background-size: 100%;
  padding-bottom: 20px;
  position: relative;
  height: 930px;
}

.bg-count {
  position: relative;
  z-index: 19;
  background-color: #fff;
  /* padding: 4%; */
  display: flex;
  justify-content: space-around;
  opacity: 0.5;
  padding: 25px 50px;
  text-align: center;
}

.symbol-wrap {
  font-size: 36px;
  color: #0169be;
}

.bg-count-item {
  position: relative;
  min-width: 180px;
}

.symbol {
  position: absolute;
  top: -2px;
  right: 19%;
  font-size: 30px;
  font-weight: 800;
}

.wpb_wrapper {
  text-align: center;
  color: #fff;
  position: absolute;
  left: 50%;
  bottom: 20px;
}

/* .nectar-bg-white {
    background-image: repeating-linear-gradient(to bottom, transparent, transparent 2px, #000 2px, #000 3px);
  
} */
.divider-vertical {
  /* border-left: 1px dashed #fff;
 height: 63%; */
  padding-top: 300px;
  padding-bottom: 300px;
  background-image: repeating-linear-gradient(to bottom,
      transparent,
      transparent 2px,
      #000 2px,
      #000 3px);
  width: 1px;
  margin: 25px auto;
  background-color: #fff;
}

.divider-vertical {
  /* background-image: repeating-linear-gradient(to bottom, transparent, transparent 2px, #000 2px, #000 3px); */
}

.bg-xuxian {
  /* width: 63%;
  margin: auto;

  top: -130px;
  height: 100%; */
  position: absolute;
  top: 0%;
  width: 70%;
  margin: auto;
  left: 15%;
}

.bg-xuxiantwo {
  width: 70%;
  /* margin: auto; */
  position: absolute;
  /* left: 50%; */
  top: 520px;
  bottom: 45px;
  left: 15%;
  /* top: -240px; */
}

.bout-boxtree-right {
  width: 49%;
}

.bout-boxtree-left {
  width: 43%;
}

/* .symbol-wrap:after {
    content: 'm';
    transform: translateX(-103%);
    position: absolute;
    top: 25px;
    left: 45px;
} */
/* .my-carousel {
  white-space: nowrap;
  overflow: hidden;
}

.carousel-item-content {
  display: inline-block;
  white-space: normal;
} */
.about-boxtree {
  padding: 6%;
  padding-bottom: 0px;
  /* padding-top: 20px; */
  background-color: #000000;
  color: #fff;
}

.link_text {
  margin-left: 20px;
  color: #fff;
  border-bottom: 1px solid #ccc;
}

.foot-titel {
  font-size: 28px;
}

.foot-li {
  list-style: none;
  line-height: 36px;
  font-size: 18px;
  cursor: pointer;
  font-family: 'Alegreya Sans' !important;
}

.foot-li:hover {
  color: #1290c9 !important;
}

.lianxi {
  font-size: 21px;
  margin: 25px 0px;
}

/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  background-color: transparent !important;
}

/deep/ .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover {
  background-color: transparent !important;
}

.ecahrt {
  position: relative;
  scale: 1.1;
  /* left: 50%; */
}

.bbb {
  position: absolute;
  left: 36%;
  top: 40%;
  font-size: 21px;
  color: #fff;
  font-family: "Open Sans" !important;
}

.nectar-bg-white {
  height: 100%;
  flex: 1;
}

.hvr-underline-bottom {
  border-bottom: 2px solid #fff;
}

.hvr-underline-black {
  border-bottom: 2px solid #000000;
}

.meta-date {
  margin-bottom: -20px;
}

.marginbottom24 {
  margin-bottom: 24px;
}

/deep/ .el-drawer.rtl {
  background-color: #5694ff;
  padding: 0px 30px 0px 30px;
  overflow-y: auto;
}

.mobilemenu .header-titleitem {
  color: #fff !important;
  font-size: 16px;
  font-family: "Open Sans" !important;
}

.mobilemenu .header-titleitem {
  background-color: transparent !important;
}

.mobilemenu /deep/ .el-submenu.is-active .el-submenu__title {
  background-color: transparent !important;
}

.mobilemenu /deep/ .el-submenu .el-submenu__title {
  background-color: transparent !important;
}

.mobilemenu /deep/ .el-menu-item {
  background-color: transparent !important;
  height: 44px !important;
  line-height: 44px !important;
}

.mobilemenu /deep/.el-menu-item {
  padding: 5px !important;
  margin-left: 35px !important;
  font-family: "Open Sans" !important;
}

.mobilemenu .header-title {
  font-size: 24px !important;
  font-family: "Open Sans" !important;
  font-weight: 500 !important;
}

.mobilemenu .mobile-header {
  margin-left: 15px !important;
  font-size: 24px;
  font-family: "Open Sans" !important;
  font-weight: 500 !important;
}

.mobilemenu /deep/ .el-submenu__title i {
  display: block !important;
  color: #fff !important;
  font-size: 16px;
}

.mobilemenu .flex-item {
  width: auto !important;
}

.mobilemenu /deep/ .el-drawer__header {
  margin-bottom: 0px !important;
  /* display: none !important; */
}

/deep/ .el-drawer__close-btn {
  /* margin-bottom: 0px !important; */
  display: none !important;
}

.moblieicon {
  float: right;
  margin-top: -25px;
  margin-right: -10px;
}

.fa-linkedin-square {
  display: flex;
  align-items: center;
}

.video-content-left p {
  font-family: "Alegreya Sans" !important;
  font-weight: normal;
}

.titleiteemu-img {
  height: 25px;
  /* width: 60px; */
  /* transform: scale(0.3); */
}

.el-icon-searchblack {
  color: #000 !important;
}

.titleiteemu-text {
  display: inline-block;
  /* width: 20%; */
  text-align: center;
}

.huibuttonabsolute {
  position: absolute;
  bottom: 20px;
  margin-right: 20px;
}

.bottom-conternttwo {
  width: 23%;
  max-width: 350px;
  /* min-height: 780px !important; */
}

.text-overhidden {
  overflow: hidden;
  /* 隐藏超出部分 */
  display: -webkit-box;
  /* 使用弹性布局 */
  -webkit-box-orient: vertical;
  /* 垂直方向的布局 */
  -webkit-line-clamp: 3;
}

.felx_center {
  display: flex;
  align-items: center;
}

.header-titleitemtwo {
  padding-left: 10px !important;
}

/* .searchmenu /deep/ .el-submenu__title i {
  display: inline-block !important;
} */
</style>